export default __webpack_public_path__ + "static/media/Flag_of_Guyana.ddfa83e3.svg";